module.exports = __webpack_public_path__ + "static/media/close-menu.41720473.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./public/images/close-menu.svg
 ** module id = 142
 ** module chunks = 0
 **/